// @flow

import {ratingSizes as Sizes} from './config.json';

export const Themes = {
    blue: 'blue',
    yellow: 'yellow'
};
export type Theme = $Values<typeof Themes>;

export {Sizes};
export type Size = $Values<typeof Sizes>;

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./config.json");
